import { render, staticRenderFns } from "./bgs-item.vue?vue&type=template&id=7c039cc9"
import script from "./bgs-item.vue?vue&type=script&lang=js"
export * from "./bgs-item.vue?vue&type=script&lang=js"
import style0 from "./bgs-item.vue?vue&type=style&index=0&id=7c039cc9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports